import type { Enums, Nullable, NullableFields, Plan } from "../types";

export function getPlanStateColor(
	plan: Nullable<Omit<NullableFields<Plan>, "createdAt" | "updatedAt" | "publishedAt">>,
): Enums<"color"> {
	switch (plan?.state) {
		case "editing":
			return "blue";
		case "published":
			return "emerald";
		case "pending":
			return "gray";
		default:
			return "gray";
	}
}
